var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyLocationLandmarkDweb = function SvgHappyLocationLandmarkDweb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#46484D",
    d: "M8.66 0C3.883 0 0 3.552 0 7.917c0 4.79 6.02 10.237 7.868 11.793a1.23 1.23 0 0 0 1.584 0c1.846-1.557 7.867-7.005 7.867-11.793C17.319 3.552 13.434 0 8.659 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.212 7.21a.54.54 0 0 0-.433-.37l-1.83-.28-.809-1.662a.56.56 0 0 0-.48-.28.55.55 0 0 0-.481.28L7.35 6.575l-1.81.265a.53.53 0 0 0-.434.37.55.55 0 0 0 .136.557l1.321 1.316-.307 1.829a.55.55 0 0 0 .213.53.53.53 0 0 0 .565.041l1.637-.865 1.62.863a.53.53 0 0 0 .564-.04.54.54 0 0 0 .213-.532l-.302-1.85 1.31-1.294a.54.54 0 0 0 .136-.554z"
  })));
};
export default SvgHappyLocationLandmarkDweb;